import * as React from "react";
const NewsClock3 = (props) => (
  <svg
    width={19}
    height={20}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.95039 1.11824C4.22118 0.901609 4.26509 0.506472 4.04845 0.23568C3.83182 -0.0351127 3.43668 -0.0790168 3.16589 0.137617L1.07287 1.81204C0.802073 2.02867 0.758169 2.42381 0.974803 2.6946C1.19144 2.96539 1.58657 3.0093 1.85737 2.79266L3.95039 1.11824Z"
      fill="#184548"
      strokeWidth={0.1}
    />
    <path
      d="M14.8341 0.137617C14.5633 -0.0790168 14.1682 -0.0351127 13.9515 0.23568C13.7349 0.506472 13.7788 0.901609 14.0496 1.11824L16.1426 2.79266C16.4134 3.0093 16.8086 2.96539 17.0252 2.6946C17.2418 2.42381 17.1979 2.02867 16.9271 1.81204L14.8341 0.137617Z"
      fill="#184548"
      strokeWidth={0.1}
    />
    <path
      d="M9.62791 6.4884C9.62791 6.14161 9.34679 5.86049 9 5.86049C8.65322 5.86049 8.3721 6.14161 8.3721 6.4884V10.0096C8.3721 10.2765 8.27012 10.5333 8.08703 10.7275L6.86871 12.0197C6.63082 12.272 6.64252 12.6694 6.89484 12.9073C7.14716 13.1452 7.54456 13.1335 7.78245 12.8812L9.00077 11.589C9.40357 11.1617 9.62791 10.5967 9.62791 10.0096V6.4884Z"
      fill="#184548"
      strokeWidth={0.1}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0.837231C4.02944 0.837231 0 4.86667 0 9.83723C0 14.8078 4.02944 18.8372 9 18.8372C13.9706 18.8372 18 14.8078 18 9.83723C18 4.86667 13.9706 0.837231 9 0.837231ZM1.25581 9.83723C1.25581 5.56024 4.723 2.09304 9 2.09304C13.277 2.09304 16.7442 5.56024 16.7442 9.83723C16.7442 14.1142 13.277 17.5814 9 17.5814C4.723 17.5814 1.25581 14.1142 1.25581 9.83723Z"
      fill="#184548"
      strokeWidth={0.1}
    />
    <path
      d="M3.95039 1.11824C4.22118 0.901609 4.26509 0.506472 4.04845 0.23568C3.83182 -0.0351127 3.43668 -0.0790168 3.16589 0.137617L1.07287 1.81204C0.802073 2.02867 0.758169 2.42381 0.974803 2.6946C1.19144 2.96539 1.58657 3.0093 1.85737 2.79266L3.95039 1.11824Z"
      stroke="#184548"
      strokeWidth={0.1}
    />
    <path
      d="M14.8341 0.137617C14.5633 -0.0790168 14.1682 -0.0351127 13.9515 0.23568C13.7349 0.506472 13.7788 0.901609 14.0496 1.11824L16.1426 2.79266C16.4134 3.0093 16.8086 2.96539 17.0252 2.6946C17.2418 2.42381 17.1979 2.02867 16.9271 1.81204L14.8341 0.137617Z"
      stroke="#184548"
      strokeWidth={0.1}
    />
    <path
      d="M9.62791 6.4884C9.62791 6.14161 9.34679 5.86049 9 5.86049C8.65322 5.86049 8.3721 6.14161 8.3721 6.4884V10.0096C8.3721 10.2765 8.27012 10.5333 8.08703 10.7275L6.86871 12.0197C6.63082 12.272 6.64252 12.6694 6.89484 12.9073C7.14716 13.1452 7.54456 13.1335 7.78245 12.8812L9.00077 11.589C9.40357 11.1617 9.62791 10.5967 9.62791 10.0096V6.4884Z"
      stroke="#184548"
      strokeWidth={0.1}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0.837231C4.02944 0.837231 0 4.86667 0 9.83723C0 14.8078 4.02944 18.8372 9 18.8372C13.9706 18.8372 18 14.8078 18 9.83723C18 4.86667 13.9706 0.837231 9 0.837231ZM1.25581 9.83723C1.25581 5.56024 4.723 2.09304 9 2.09304C13.277 2.09304 16.7442 5.56024 16.7442 9.83723C16.7442 14.1142 13.277 17.5814 9 17.5814C4.723 17.5814 1.25581 14.1142 1.25581 9.83723Z"
      stroke="#184548"
      strokeWidth={0.1}
    />
  </svg>
);
export default NewsClock3;
